import type { ReactNode } from 'react'

// Shared gold-on-navy section heading (#7r2). Marketing pattern:
// centered, bold, gold (~h5 = 24px in MUI), generous vertical margin.
// No accent line, no prefix, no subtitle — just the title.

interface Props {
  id?: string
  children: ReactNode
}

export function SectionHeading({ id, children }: Props) {
  return (
    <h2 id={id} className="text-gold text-2xl sm:text-3xl font-extrabold text-center scroll-mt-20">
      {children}
    </h2>
  )
}
